<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>

        <div class="card-header-actions">
          Total : {{item.length}}
        </div>

      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <CDataTable
                :table-filter="{label:''}"
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                :items="item"
                :fields="fields"
                :items-per-page="small ? 100 : 10"
                :dark="dark"
                :loading="loading"
                pagination
                :items-per-page-select="pages"
                sorter
            >
              <template #index="{item,index}">
                <td class="text-center font-weight-bold"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
              </template>

              <template #code="{item,index}">
                <td class="text-right font-weight-bold"  @click="toggleDetails(item, index)"> {{ item.code}}</td>
              </template>


              <template #completed="{item,index}">
                <td class="text-center font-weight-bold"  @click="toggleDetails(item, index)"> {{ item.completed.length }}</td>
              </template>


<!--              <template #title="{item,index}">-->
<!--                <td class="font-weight-bold" @click="toggleDetails(item, index)"> {{ item.title.filter(title => { if (title.key == lang) { return title } })[0].value }}</td>-->
<!--              </template>-->


              <template #competencyLevel="{item,index}">
                <td class="text-center font-weight-bold"  @click="toggleDetails(item, index)"> {{ item.competencyLevel}}</td>
              </template>
              <template #assessment0="{item,index}">
                <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment0)" @click="toggleDetails(item, index)"> {{ item.assessment0}}</td>
              </template>

              <template #assessment1="{item,index}">
                <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment1)"  @click="toggleDetails(item, index)"> {{ item.assessment1}}</td>
              </template>

              <template #assessment2="{item,index}">
                <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment2)" @click="toggleDetails(item, index)"> {{ item.assessment2}}</td>
              </template>

              <template #gapSum="{item,index}">
                <td class="text-center font-weight-bold"  @click="toggleDetails(item, index)"> {{ item.gapSum}}</td>
              </template>




              <template #total="{item,index}">
                <td class="text-center font-weight-bold"  @click="toggleDetails(item, index)"> {{  item.item.length }}</td>
              </template>


              <template #member="{item,index}">
                <td class="text-center font-weight-bold"  @click="toggleDetails(item, index)"> {{ item.member}}</td>
              </template>

              <template #isGap="{item,index}">
                <td class="text-right font-weight-bold"  :class="((item.member === 0)?0:((item.isNoGap/item.member)*100) >= 10)?'text-success':'text-danger'" @click="toggleDetails(item, index)"> {{ item.isGap}} ( {{  (item.member === 0)?"0.00":((item.isGap/item.member)*100).toFixed(2) }} %)</td>
              </template>

              <template #isNoGap="{item,index}">
                <td class="text-right font-weight-bold"  :class="((item.member === 0)?0:((item.isNoGap/item.member)*100) >= 10)?'text-success':'text-danger'" @click="toggleDetails(item, index)">  {{ item.isNoGap}} ( {{ (item.member === 0)?"0.00":((item.isNoGap/item.member)*100).toFixed(2)}} %)</td>
              </template>





              <template #action="{item,index}">
                <td style="width: 140px">
                  <CRow>
                    <CCol class="text-center">
                      <CButton class="mr-1" v-c-tooltip.hover.click="'Info'" size="sm" color="success" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >
                        <CIcon name="cil-description"/>
                      </CButton>

                    </CCol>
                  </CRow>
                </td>
              </template>

              <template #details="{item}">
                <CCollapse :show=" Boolean(item._toggled)" :duration="collapseDuration">
                  <CCardBody>

                    <CRow v-if="item.explorerAgency != undefined ">
                      <CCol col="12">
                        <p class="font-weight-bold"> <CIcon name="cil-badge"/> สรุปผลการประเมินโดยรวมของหน่วยงาน</p>
                      </CCol>
                      <CCol>
                        <CDataTable

                            :fields="childrenAgency"
                            :items="item.explorerAgency"

                            :items-per-page="20"
                            hover
                            sorter
                        >
                          <template #index="{item,index}">
                            <td class="text-center" @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                          </template>


                          <template #title="{item,index}">
                            <td   @click="toggleDetails(item, index)"> {{ item.title.filter(title => { if (title.key == lang) { return title } })[0].value  }}</td>
                          </template>

                          <template #isGap="{item,index}">
                            <td class="text-center" @click="toggleDetails(item, index)"> {{ item.isGap  }}</td>
                          </template>


                          <template #member="{item,index}">
                            <td class="text-center" @click="toggleDetails(item, index)"> {{ item.total  }}</td>
                          </template>


                          <template #total="{item,index}">
                            <td class="text-center" @click="toggleDetails(item, index)"> {{ ((item.isGap/item.total)*100).toFixed(2)  }}</td>
                          </template>



                          <template #experiences="{item,index}">
                            <td class="text-right"  @click="toggleDetails(item, index)">
                              <span>{{ moment(item.dateTime).format("YYYY-MM-DD")  }}</span>
                              ( <span class="font-weight-bold">{{ item.experiences }}</span>  )
                            </td>
                          </template>
                          <template #action="{item,index}">
                            <td style="width: 140px">
                              <CRow>
                                <CCol class="text-center">
                                  <CButton class="mr-1" v-c-tooltip.hover.click="'Info'" size="sm" color="success" shape="pill" variant="outline" @click="toggleDetails(item,index)"  >
                                    <CIcon name="cil-description"/>
                                  </CButton>

                                </CCol>
                              </CRow>
                            </td>
                          </template>
                        </CDataTable>
                      </CCol>
                      <CCol col="12">
                        <CDropdownDivider/>
                      </CCol>
                    </CRow>


                    <CDataTable
                        :table-filter="{label:''}"
                        :fields="childrenFields"
                        :items="item.item"
                        items-per-page-select
                        :items-per-page="20"
                        hover
                        sorter
                        pagination
                    >
                      <template #index="{item,index}">
                        <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                      </template>


                      <template #competencyLevel="{item,index}">
                        <td class="text-center font-weight-bold"  @click="toggleDetails(item, index)"> {{ item.competencyLevel}}</td>
                      </template>
                      <template #assessment0="{item,index}">
                        <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment0)" @click="toggleDetails(item, index)"> {{ item.assessment0}}</td>
                      </template>

                      <template #assessment1="{item,index}">
                        <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment1)"  @click="toggleDetails(item, index)"> {{ item.assessment1}}</td>
                      </template>

                      <template #assessment2="{item,index}">
                        <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment2)" @click="toggleDetails(item, index)"> {{ item.assessment2}}</td>
                      </template>

                      <template #gapSum="{item,index}">
                        <td class="text-center font-weight-bold" :class="color(0,item.gapSum)" @click="toggleDetails(item, index)"> {{ item.gapSum }}</td>
                      </template>


                      <template #action="{item,index}">
                        <td style="width: 140px">
                          <CRow>
                            <CCol class="text-center">
                              <CButton class="mr-1" v-c-tooltip.hover.click="'Info'" size="sm" color="success" shape="pill" variant="outline" @click="toggleDetails(item,index)"  >
                                <CIcon name="cil-description"/>
                              </CButton>

                            </CCol>
                          </CRow>
                        </td>
                      </template>


                      <template #details="{item,index}">
                        <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
                          <CTabs add-tab-classes="mt-1">
                            <CTab>
                              <template slot="title">
                                <CIcon name="cil-briefcase"/> ตำแหน่งงาน
                              </template>
                              <CCardBody>
                                <CDataTable
                                    :fields="field.position"
                                    :items="item.positions"
                                    items-per-page-select
                                    :items-per-page="20"
                                    hover
                                    sorter
                                    pagination
                                >
                                  <template #index="{item,index}">
                                    <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                                  </template>

                                  <template #info="{item,index}">
                                    <td @click="toggleDetails(item, index)">
                                      <!--                              <span>{{ item.agencies.title.filter(title => { if (title.key == lang) { return title } })[0].value}}</span> <br>-->
                                      <span>{{ item.agency.title.filter(title => { if (title.key == lang) { return title } })[0].value}}</span>
                                    </td>
                                  </template>

                                  <template #position="{item,index}">
                                    <td @click="toggleDetails(item, index)">
                                      <span>{{ item.type.title.filter(title => { if (title.key == lang) { return title } })[0].value}}</span> <br>
                                      <span>{{ item.name.title.filter(title => { if (title.key == lang) { return title } })[0].value}}</span>
                                      <!--                              <p>{{ item.work.title.filter(title => { if (title.key == lang) { return title } })[0].value}}</p>-->
                                      <p></p>
                                    </td>
                                  </template>

                                  <template #code="{item,index}">
                                    <td @click="toggleDetails(item, index)">
                                      <span> Code : {{ item.code }} </span> <br>
                                      <span> Status : {{ item.status.title.filter(title => { if (title.key == lang) { return title } })[0].value}} </span>
                                    </td>
                                  </template>


                                  <template #dateTime="{item,index}">
                                    <td class="text-right"  @click="toggleDetails(item, index)">
                                      <span> StartDate : {{ new moment(item.startDate).format("YYYY-MM-DD") }} </span> <br>
                                      <span> EndDate : {{ new moment(item.endDate).format("YYYY-MM-DD") }} </span>
                                    </td>
                                  </template>



                                </CDataTable>
                              </CCardBody>
                            </CTab>
                          </CTabs>
                        </CCollapse>
                      </template>

                    </CDataTable>
                  </CCardBody>
                </CCollapse>
              </template>

            </CDataTable>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: 'Historys',
  props: {
    icon: {
      type: String,
      default: 'cil-calculator'
    },
    caption: {
      type: String,
      default: 'ReportStatus'
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"code", label:"Code", _style: 'width:80px; text-align: center'},
          // {key:"avata", label:"", _style: 'width:50px; text-align: center'},
          // {key:"members", label:"Member",  _style: 'width:200px;'},
          {key:"title", label:"Title",},
          // {key:"info", label:"Info",},
          // {key:"dateTime", label:"Last Update",  _style: 'width:190px; text-align: center'},
          {key:"action", label: "#"}
          // {key:"attend", label:"Attend Class",  _style: 'width:200px; text-align: center'}
        ]
      }
    },
    childrenFields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
        ]
      }
    },

    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    loading: Boolean,
    pages:{
      type: Object,
      default() {
        return {
          values:[10,20,50,100]
        }
      }
    },


    item: {
      type: Array,
      default() {
        return []
      }
    },
  },

  data: function () {
    return {
      collapseDuration: 0,
      field: {
        position:[
          // {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
          {key: "code", label: "Code", _style: 'width:200px; text-align: center'},
          {key: "info", label: "Info"},
          {key: "position", label: "Position"},
          {key: "dateTime", label:"DateTime",  _style: 'width:190px; text-align: center'},
        ]
      },
      childrenAgency:[
        {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
        {key:"title", label:"ประเภทสมรรถนะ", },
        {key:"member", label:"จำนวนรวม",  _style: 'width:100px; text-align: center'},
        {key:"isGap", label:" ผู้ติด GAP",  _style: 'width:100px; text-align: center'},
        {key:"total", label: "ร้อยละ" ,  _style: 'width:100px; text-align: center'},
      ]

    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    errorImage(e) {
      e.target.src = "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
    },

    toggleDetails (item, index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})

    },
    color(level,checck){
      if(level > checck){
        return "text-danger"
      }else if(level == checck){
        return "text-success"
      }else{
        return "text-info"
      }

    }



  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
